import React, { useState } from 'react';
import { Search, ChevronLeft, ChevronRight, Eye, MapPin, Globe, Shield, Smartphone } from 'lucide-react';

const VisitorsTab = ({
  visitors,
  totalVisitors,
  page,
  totalPages,
  setPage,
  setSelectedTelemetryVisitor,
  getCountryFlag,
  getDeviceIcon,
  getBrowserIcon,
  formatDate
}) => {
  const [searchTerm, setSearchTerm] = useState('');

  const filteredVisitors = visitors.filter((v) => {
    const q = searchTerm.toLowerCase();
    return (
      (v.ip && v.ip.toLowerCase().includes(q)) ||
      (v.city && v.city.toLowerCase().includes(q)) ||
      (v.country && v.country.toLowerCase().includes(q)) ||
      (v.referrer && v.referrer.toLowerCase().includes(q)) ||
      (v.device && v.device.toLowerCase().includes(q))
    );
  });

  return (
    <div className="tab-pane visitors-pane">
      {/* Table Toolbar */}
      <div className="table-toolbar">
        <div className="search-box">
          <Search className="search-icon" />
          <input
            type="text"
            placeholder="Search IP, City, Country, Device, Referrer..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className="search-input"
          />
        </div>

        <div className="toolbar-stats-group">
          <span className="stat-pill">
            TOTAL RECORDS: <strong>{totalVisitors}</strong>
          </span>
          <span className="stat-pill">
            SHOWING: <strong>{filteredVisitors.length}</strong>
          </span>
        </div>
      </div>

      {/* Visitors Cyber Table Container */}
      <div className="cyber-table-container">
        <table className="cyber-table">
          <thead>
            <tr>
              <th>TIMESTAMP</th>
              <th>IP &amp; NETWORK</th>
              <th>LOCATION</th>
              <th>DEVICE / BROWSER</th>
              <th>SOURCE</th>
              <th>TELEMETRY</th>
            </tr>
          </thead>
          <tbody>
            {filteredVisitors.length === 0 ? (
              <tr>
                <td colSpan="6" className="empty-table-cell">
                  No visitor records matched your search query.
                </td>
              </tr>
            ) : (
              filteredVisitors.map((v) => (
                <tr key={v._id || v.id} className="table-row">
                  <td className="time-cell">
                    <span className="primary-time">{formatDate(v.timestamp || v.createdAt)}</span>
                  </td>

                  <td className="ip-cell">
                    <span className="ip-addr">{v.ip}</span>
                    <span className="isp-name">{v.isp || 'Network Provider'}</span>
                  </td>

                  <td className="location-cell">
                    <div className="location-info">
                      <span className="flag">{getCountryFlag(v.country)}</span>
                      <div className="loc-text">
                        <span className="city">{v.city || 'Unknown City'}</span>
                        <span className="country">{v.country || 'Unknown Country'}</span>
                      </div>
                    </div>
                  </td>

                  <td className="device-cell">
                    <div className="device-pills">
                      <span className="dev-pill">
                        {getDeviceIcon(v.device)} {v.device || 'Desktop'}
                      </span>
                      <span className="browser-pill">
                        {getBrowserIcon(v.browser)} {v.browser || 'Chrome'}
                      </span>
                    </div>
                  </td>

                  <td className="source-cell">
                    <span className="source-tag">{v.referrer || 'Direct'}</span>
                  </td>

                  <td className="action-cell">
                    <button
                      className="inspect-btn"
                      onClick={() => setSelectedTelemetryVisitor(v)}
                    >
                      <Eye size={13} />
                      <span>INSPECT</span>
                    </button>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>

      {/* Pagination Bar */}
      <div className="pagination-bar">
        <button
          className="page-btn"
          disabled={page <= 1}
          onClick={() => setPage((prev) => Math.max(prev - 1, 1))}
        >
          <ChevronLeft size={16} />
          <span>PREVIOUS</span>
        </button>

        <span className="page-indicator">
          PAGE <strong>{page}</strong> OF <strong>{totalPages}</strong>
        </span>

        <button
          className="page-btn"
          disabled={page >= totalPages}
          onClick={() => setPage((prev) => Math.min(prev + 1, totalPages))}
        >
          <span>NEXT</span>
          <ChevronRight size={16} />
        </button>
      </div>
    </div>
  );
};

export default VisitorsTab;
